import { render } from "./WearSelect.vue?vue&type=template&id=733f836b"
import script from "./WearSelect.vue?vue&type=script&lang=js"
export * from "./WearSelect.vue?vue&type=script&lang=js"

import "./WearSelect.vue?vue&type=style&index=0&id=733f836b&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__